import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../../../shared/services/appsettings.service';

@Component({
  selector: 'app-error500',
  template: require('./error500.component.html'),
  styles: [require('./error500.component.scss')]
})
export class Error500Component implements OnInit {

    constructor(public settings: AppSettingsService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/routes/pages/error500/error500.component.ts